import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { Box as e } from "@mui/material";
import { Typography as l } from "./index59.mjs";
import { progressBarDescriptionClasses as s } from "./constants4.mjs";
import { mergeClassNames as n } from "./mergeClassNames.mjs";
const B = ({
  children: a,
  className: i,
  icon: r,
  sx: t,
  ...c
}) => /* @__PURE__ */ p(
  e,
  {
    ...c,
    sx: {
      display: "flex",
      alignItems: "center",
      gap: (m) => m.spacing(1.5),
      ...t
    },
    className: n([s.root, i]),
    children: [
      /* @__PURE__ */ o(
        l.Body2,
        {
          color: "text.secondary",
          className: s.description,
          children: a
        }
      ),
      r && /* @__PURE__ */ o(
        e,
        {
          className: s.icon,
          color: "action.active",
          sx: { display: "flex", alignItems: "center" },
          children: r
        }
      )
    ]
  }
);
export {
  B as ProgressBarDescription
};
//# sourceMappingURL=index134.mjs.map
